import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import PropertyDocument from "../components/PropertyDetalis/PropertyDocument";
import PropertyImages from "../components/PropertyDetalis/PropertyImages";
import RecentPropertiesList from "../components/RecentProperties/RecentPropertiesList";
import Loader from "../components/common/Loader";
import { api, investorApi, vendorApi } from "../api/api";
import ScreenContainer from "../components/common/screencontainer";
import Description from "../components/common/Description";
import { useParams, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const PropertyDetailsScreen = () => {
  const { userId, isAuthenticated } = useSelector((state) => state.user);
  const { slug } = useParams();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const referralCode = queryParams.get("ref");

  let propertyId = null;

  if (slug) {
    const parts = slug.split("-");
    propertyId = parts[parts.length - 1];
  }

  const [propertyData, setPropertyData] = useState([]);
  const [loading, setLoading] = useState(true);

  /* =========================================================
     STEP 1: STORE REFERRAL (FIRST CLICK ONLY)
  ========================================================== */
  useEffect(() => {
    if (referralCode) {
      const existingRef = localStorage.getItem("referralCode");

      if (!existingRef) {
        localStorage.setItem("referralCode", referralCode);
      }
    }
  }, [referralCode]);

  /* =========================================================
     STEP 2: FETCH PROPERTY DETAILS
  ========================================================== */
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const getPropertyAndFetchDetails = async () => {
      try {
        const response = await investorApi.getPropertyDetails(propertyId);

        if (response.status === 200) {
          const normalizedData = Array.isArray(response.data)
            ? response.data
            : [response.data];

          setPropertyData(normalizedData);
        }
      } catch (err) {
        console.error(
          "Error fetching property details:",
          err?.response?.data || err.message || err
        );
      } finally {
        setLoading(false);
      }
    };

    if (propertyId) {
      getPropertyAndFetchDetails();
    }
  }, [propertyId]);


  /* =========================================================
     STEP 3: APPLY REFERRAL AFTER LOGIN
  ========================================================== */
  useEffect(() => {
    const applyReferral = async () => {
      if (!isAuthenticated || !userId) return;

      const storedRef = localStorage.getItem("referralCode");
      if (!storedRef) return;

      // Prevent self referral
      if (storedRef == userId) {
        localStorage.removeItem("referralCode");
        return;
      }

      try {
        const fd = new FormData();
        fd.append("userId", userId);
        fd.append("refererId", storedRef);
        fd.append("propertyId", propertyId);

        const res = await vendorApi.addProjectUserMapping(fd);

        // console.log("Referral applied:", res);

        localStorage.removeItem("referralCode");
      } catch (error) {
        console.error("Referral error:", error);
      }
    };

    applyReferral();
  }, [isAuthenticated, userId, propertyId]);

  /* =========================================================
     UI LAYOUT CONFIG
  ========================================================== */
  const layoutConfig = [
    {
      id: "PropertyImages",
      render: () => <PropertyImages data={propertyData} />,
    },
    {
      id: "PropertyDescription",
      render: () => <Description data={propertyData} />,
    },
    // ...(propertyData?.[0]?.Status === "sale Initiated" ||
    //   propertyData?.[0]?.Status === "Sold"
    //   ? [
    //     {
    //       id: "PropertyDocument",
    //       render: () => (
    //         <PropertyDocument
    //           data={propertyData?.[0]?.id}
    //           userId={userId}
    //           type={propertyData?.[0]?.type}
    //         />
    //       ),
    //     },
    //   ]
    //   : []),
    ...(propertyData?.[0]?.Status !== "sale Initiated" &&
      propertyData?.[0]?.Status !== "Sold"
      ? [
        {
          id: "RecentProperties",
          render: () => (
            <RecentPropertiesList
              userId={userId}
              type={propertyData?.[0]?.type}
              propertyId={propertyData?.[0]?.id}
            />
          ),
        },
      ]
      : []),
  ];

  return (
    <ScreenContainer>
      <Helmet>
        <title>
          {propertyData?.[0]?.PropertyName
            ? `${propertyData?.[0]?.PropertyName} for Sale in ${propertyData?.[0]?.Address} | Villas, Plots & Apartments | JEMINS Builders & Developers Private Limited`
            : "Property Details | JEMINS Builders & Developers Private Limited"}
        </title>

        <meta
          name="description"
          content={
            propertyData?.[0]?.description
              ? propertyData[0].description.substring(0, 160)
              : "Explore premium properties with JEMINS Builders & Developers Private Limited."
          }
        />

        <meta
          property="og:title"
          content={propertyData?.[0]?.PropertyName || "JEMINS Builders & Developers Private Limited"}
        />
        <meta
          property="og:description"
          content={propertyData?.[0]?.description}
        />
        <meta
          property="og:image"
          content={propertyData?.[0]?.images?.[0]}
        />
        <meta
          property="og:url"
          content={window.location.href}
        />
      </Helmet>
      {loading ? (
        <Loader />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "30px",
            padding: "5px",
          }}
        >
          {layoutConfig.map((section) => (
            <div key={section.id}>{section.render()}</div>
          ))}
        </Box>
      )}
    </ScreenContainer>
  );
};

export default PropertyDetailsScreen;